<template>
  <div></div>
</template>

<script setup lang="ts">
definePageMeta({
  layout: false
})

const rootStore = useRootStore();
const router = useRouter();
const route = useRoute();

const withDrawal = reactive({
  yn: 'N',
  userId: '',     // 회원 ID
  memo: '',       // 탈퇴 내용
  reasonCode: '', // 탈퇴 사유코드
});

/**
 * 회원 탈퇴 처리 후 카카오가 아닌 다른 SNS 연동 해제 후
 * 카카오 연동 해제 처리합니다.
 */
onMounted(() => {
  if (route.query.state) {
    const stateParam = `${route.query.state}`;
    const stateArr = stateParam.split('[sp]');
    if (stateArr.length === 2 && stateArr[0] === 'withdrawal') {
      withDrawal.yn = 'Y';
      withDrawal.userId = stateArr[1];
    }
  }
  
  // 인수값이 유효하지 않을 경우
  if (withDrawal.yn === 'N') {
    router.replace('/');
    return;
  }
  
  // 탈퇴 입력정보 조회
  const localWithdrawalData = localStorage.getItem('withdrawal');
  if (localWithdrawalData) {
    const withdrawalData = JSON.parse(localWithdrawalData);
    if (withdrawalData.userId === withDrawal.userId) {
      withDrawal.memo = withdrawalData.withdrawalContent;
      withDrawal.reasonCode = withdrawalData.withdrawalReason;
    }
  }
      
  init();
});

const init = async (): Promise<void> => {
  const config = useRuntimeConfig();
  
  // access token 가져오기
  const accessToken = await getAcessTokenForKakao(`${route.query.code}`, `${checkURL()}/callbackWithDrawalKakao`);
  
  if (!accessToken) {
    rootStore.showMessageDialog(
      '페이지를 새로고침하고 다시 로그인해 주세요.\n문제가 계속되면 고객센터로 문의해주세요.', 
      '확인', 
      () => { router.replace('/') }
    );
  } else {
    snsUnlink(accessToken);
  }
};

// 연동해제 및 탈퇴처리
const snsUnlink = async (accessToken: string): Promise<void> => {
  // sns id 조회
  const data = await searchKakaoProfile(accessToken);
  if (!data) {
    rootStore.showMessageDialog(
      '카카오 계정이 올바르지 않습니다.', 
      '확인', 
      () => { router.push('/') }
    );
    return;
  }
  
  const snsId = data.id;
  
  let linked = false;
  const check = await checkSNSLinked(snsId, 'kakao', withDrawal.userId);
  if (check === 1) {
    linked = true;
  } else if (check === 0) {
    await unlinkSNS('kakao', accessToken);
  }
  
  if (!linked) {
    localStorage.removeItem('withdrawal'); // 탈퇴 내용 제거
    localStorage.removeItem('unlinkSNS'); // 네이버 연동해제 정보 삭제
    
    rootStore.showMessageDialog(
      '로그인된 카카오 계정과 연결되어 있지 않습니다.', 
      '확인', () => { 
        router.replace('/');
      }
    );
    return;
  }
  
  // 탈퇴처리
  const result = await memberWithdrawal({
    withdrawalReason: withDrawal.reasonCode,
    withdrawalContent: withDrawal.memo,
  });
  
  if (!result) return;
  
  // 다른 SNS 연동 해제
  const localUnlinkSNSData = localStorage.getItem('unlinkSNS');
  if (localUnlinkSNSData) {
    const unlinkSNSData = JSON.parse(localUnlinkSNSData);
    for (let i = 0; i < unlinkSNSData.length; i++) {
      await unlinkSNS(unlinkSNSData[i].route, unlinkSNSData[i].access_token);
    }
  }
  localStorage.removeItem('unlinkSNS');
  
  // 카카오 연동해제
  await unlinkSNS('kakao', accessToken);
  
  rootStore.showMessageDialog(
    '정상적으로 회원 탈퇴가 이뤄졌습니다.<br>그 동안 이용해 주셔서 감사합니다.', 
    '확인', 
    () => { logout() }
  );
};
</script>